
import { mapGetters } from 'vuex'
// import Dropzone from './Dropzone.vue'
import HomeworkList from './HomeworkList.vue'
export default {
  components: { /*Dropzone,*/ HomeworkList },
  data() {
    return {
      isSending: false,
      files: [],
      activeAssignment: {},
      removeConfirmModal: false,
      loading: false,
      uploadProgress: {
        totalChunks: 0,
        currentChunk: 0,
        isUploading: false,
      },
    }
  },
  props: {
    productId: {
      default: -1,
    },
    type: {
      default: -1,
    },
  },
  computed: {
    ...mapGetters({
      getUploadingProgress: 'api/getUploadingProgress',
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    SET_REMOVE_FILE(index, childIndex) {
      this.GET_USER_FILES()
    },
    async DOWNLOAD_FILE(file) {
      if (file.filePath.includes('eocademy/Assignments')) {
        const response = await this.$api.get(
          'UserAssignments/DownloadFile?userAssignmentId=' + file.id
        )
        if (response.message === 'OK') {
          window.open(response.data.fileUrl, '_blank')
        }
      }
    },
    async sendChunk(
      file,
      assignmentId,
      chunk,
      order,
      isLastPart,
      fileName,
      note
    ) {
      const fd = new FormData()
      fd.append('File', chunk)
      fd.append('AssignmentId', assignmentId)
      fd.append('Order', order)
      fd.append('IsLastPart', isLastPart)
      fd.append('FileName', fileName)
      fd.append('Note', note)

      return await this.$api.post('UserAssignments/InsertFile', fd)
    },
    randomUUID() {
      const uuid = Array.from({ length: 16 }, () =>
        Math.floor(Math.random() * 256).toString(16)
      ).join('')
      return uuid
    },
    async DOWNLOAD_FILE(file) {
      if (file.filePath.includes('eocademy/Assignments')) {
        const response = await this.$api.get(
          'UserAssignments/DownloadFile?userAssignmentId=' + file.id
        )
        if (response.message === 'OK') {
          window.open(response.data.fileUrl, '_blank')
        }
      }
    },
    async SEND_FILES(files, id, index) {
      if (this.productId === -1) return
      this.isSending = true

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const chunkSize = 1024 * 1024 * 10 // 10MB chunk size
        const totalChunks = Math.ceil(file.size / chunkSize)
        const fileName = `${this.randomUUID()}_${file.name}`
        const note = prompt('Dosya için not ekleyin (isteğe bağlı):', '')

        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          const start = chunkIndex * chunkSize
          let end = Math.min(start + chunkSize, file.size)
          if (end + 1024 * 1024 >= file.size) {
            end = file.size
          }
          const chunk = file.slice(start, end)
          const isLastPart = chunkIndex === totalChunks - 1
          this.uploadProgress.totalChunks = totalChunks
          this.uploadProgress.currentChunk = chunkIndex + 1
          this.uploadProgress.isUploading = true

          const response = await this.sendChunk(
            file,
            id,
            chunk,
            chunkIndex + 1,
            isLastPart,
            fileName,
            note
          )

          if (response.message === 'OK' && isLastPart) {
            this.uploadProgress.isUploading = false
            this.GET_USER_FILES()
          }
        }
      }
      this.isSending = false
    },
    async GET_USER_FILES() {
      this.loading = true
      const response = await this.$api.get(
        `Assignments/ByUser?parentId=${this.productId}&type=${this.type}`
      )
      if (response.message === 'OK') {
        this.files = response.data
      }
      this.loading = false
    },
  },
  mounted() {
    this.GET_USER_FILES()
  },
}
